export default [
  { text: 'Электронная почта', value: 'email' },
  { text: 'Имя', value: 'first_name' },
  { text: 'Фамилия', value: 'last_name' },
  { text: '', value: 'actions', align: 'right', width: '75px' },
]
